import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Tone from 'tone';
import PlayButton from 'components/user/PlayButton.js';
import { connect } from "react-redux";
import ReactBootstrapSlider from 'react-bootstrap-slider';

class MixPlayerPane extends Component {
    constructor(props) {
        super(props);

        this.play = this.play.bind(this);
    }

    play() {
        if (this.isPlaying()) {
            for (let i in this.props.isPlaying) {
                if (this.props.isPlaying[i]) {
                    for (let j in this.props.tracks) {
                        if (this.props.tracks[j].id === i) {
                            this.props.multiSequencerEngine.play(this.props.tracks[j]);
                        }
                    }
                }
            }
        } else {
            this.props.multiSequencerEngine.play(this.props.tracks[0]);
        }
    }

    isPlaying() {
        let count = Object.keys(this.props.isPlaying).filter(
            id => this.props.isPlaying[id]).length;
        return count > 0;
    }

    onChangeBPM(bpm) {
        this.props.multiSequencerEngine.updateBpm(bpm);
    }

    render() {
        if (this.props.tracks.length === 0) {
            return (
                <div></div>
            );
        }
        return (
            <div className="mix-player-pane">
              <div className="mix-controls-container">

                <PlayButton play={this.play} isPlaying={this.isPlaying()}/>
                <div className="bpm-container">
                  <div className="bpm-label">
                    BPM: {this.props.bpm}
                  </div>
                  <div className="clear-fix"/>
                  <div className="spotlight-fader">
                    <ReactBootstrapSlider
                      value={this.props.bpm}
                      change={(e) => this.onChangeBPM(e.target.value)}
                      step={1}
                      className="spotlight-fader"
                      max={250}
                      min={1}
                      orientation="horizontal"
                      reversed={false}/>
                  </div>
                </div>
              </div>
              <div>
                {this.props.children}
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        isPlaying: state.sequencer.isPlaying,
        viewMode: state.user.viewMode,
        currentMix: state.user.currentMix,
        loadedTracks: state.user.loadedTracks,
        bpm: state.user.bpm,
    };
};

export default connect(mapStateToProps, undefined)(MixPlayerPane);
